import * as React from 'react';
import ContractDetailsMenu from 'components/ContractDetailsMenu';
import SectionEnum from 'components/StaffContractDetailsPage/SectionEnum';
import { languageStore, customFieldStore, DashboardContractTypeEnum, userStore } from 'stores';
import { observer } from 'mobx-react';

@observer class Menu extends React.Component {

    render() {
        const miscItems = [
            {
                title: languageStore.get('status'),
                hash: SectionEnum.STATUS
            }
        ];

        if (userStore.signedInUser!.company.allowCustomFields && customFieldStore.hasCustomFields[DashboardContractTypeEnum.STAFF]) {
            miscItems.unshift({
                title: languageStore.get('customFields'),
                hash: SectionEnum.CUSTOM_FIELDS
            })
        };

        return (
            <ContractDetailsMenu
                sections={[
                    {
                        title: languageStore.get('general'),
                        items: [
                            {
                                title: languageStore.get('overview'),
                                hash: SectionEnum.OVERVIEW
                            },
                            {
                                title: languageStore.get('emergencyContact'),
                                hash: SectionEnum.EMERGENCY_CONTACT
                            },
                            {
                                title: languageStore.get('dates'),
                                hash: SectionEnum.DATES
                            },
                            {
                                title: languageStore.get('agreement'),
                                hash: SectionEnum.AGREEMENT
                            },
                            {
                                title: languageStore.get('appraisalInterview'),
                                hash: SectionEnum.APPRAISAL_INTERVIEWS
                            },
                            {
                                title: languageStore.get('educationDetails'),
                                hash: SectionEnum.EDUCATION_DETAILS
                            },
                            {
                                title: languageStore.get('perks'),
                                hash: SectionEnum.BENEFITS
                            },
                            {
                                title: languageStore.get('personalEquipment'),
                                hash: SectionEnum.EQUIPMENT
                            },
                            {
                                title: languageStore.get('skill'),
                                hash: SectionEnum.SKILL
                            },
                            {
                                title: languageStore.get('notes'),
                                hash: SectionEnum.NOTES
                            }
                        ]
                    },
                    {
                        title: languageStore.get('administration'),
                        items: [
                            {
                                title: languageStore.get('alarms'),
                                hash: SectionEnum.EXTRA_ALARMS
                            },
                            {
                                title: languageStore.get('verifiedBy'),
                                hash: SectionEnum.VERIFIED_BY
                            }
                        ]
                    },
                    {
                        title: languageStore.get('files'),
                        items: [
                            {
                                title: languageStore.get('applicantCV'),
                                hash: SectionEnum.APPLICANT_CV
                            },
                            {
                                title: languageStore.get('contracts'),
                                hash: SectionEnum.FILES_CONTRACT
                            },
                            {
                                title: languageStore.get('linkedContracts'),
                                hash: SectionEnum.LINKED_CONTRACTS
                            },
                            {
                                title: languageStore.get('correspondence'),
                                hash: SectionEnum.FILES_CORRESPONDENCE
                            }
                        ]
                    },
                    {
                        title: languageStore.get('misc'),
                        items: miscItems
                    }
                ]} />
        )
    }

}

export default Menu;